import { render, staticRenderFns } from "./detailTabPendidikan.vue?vue&type=template&id=3711f292"
import script from "./detailTabPendidikan.vue?vue&type=script&lang=js"
export * from "./detailTabPendidikan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports